import { GridValidRowModel } from '@mui/x-data-grid-premium'

/**
 * Used by `react-dnd` to identify the type of drag event
 */
export const GridTableDragType = {
  ROW: 'ROW', // Default drag type if dragType is not provided
  SHIFT_STOP_ROW: 'SHIFT_STOP_ROW',
  INBOX_ORDER_ROW: 'INBOX_ORDER_ROW',
  UNASSIGNED_ORDER_ROW: 'UNASSIGNED_ORDER_ROW',
} as const

export type GridTableType = keyof typeof GridTableDragType


/**
 * Used to communicate information from the different drag sources
 */
export type BaseGridTableDragItem = {
  id: string | number
  type: GridTableType
  rows: GridValidRowModel[] // The rows being dragged
}

export type GridTableDragItem = BaseGridTableDragItem

